<!-- <mat-card>
      <h3>Criteria</h3>
      <p>Before you submit please be advised that only events meeting the following criteria will be accepted.</p>
     <input type="button" class="btn btn-default" value="View Criteria" aria-label="View Criteria" title="View Criteria" (click)="openCriteriaDialog()">
  </mat-card> -->


<input type="button" class="btn btn-secondary no-focus" value="View Criteria" aria-label="View Criteria"
      title="View Criteria" (click)="openCriteriaDialog()">